import {
  fetchBasedCall,
  getIpFromHeaders,
  type IHttpCall,
  type IHttpRequest,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import { UpdateProspectDto } from './update-prospect.types';

type CreateProspectOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export async function updateProspectService(
  baseUrl: string,
  body: UpdateProspectDto,
  options?: CreateProspectOptions,
): Promise<IHttpResponse<undefined>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const data = { ...body };

  if (typeof data.ipAddress !== 'string') {
    const ipAddress = getIpFromHeaders(
      await (await import('next/headers')).headers(),
    );

    if (typeof ipAddress === 'string') {
      data.ipAddress = ipAddress;
    }
  }

  const request: IHttpRequest<UpdateProspectDto> = {
    url: `${baseUrl}/api/v2/prospects/`,
    method: 'POST',
    headers,
    body: data,
    schemas: {
      request: UpdateProspectDto,
      response: undefined,
    },
    ...restOptions,
  };

  return httpCall(request);
}
